import React from 'react';
import '../App.scss';

export default function Lightbox({ openBox, image, closeBox, showPrev, showNext, onPrev, onNext }) {
    return (
        <div>
            <div
                className="lightbox-wrapper"
                style={{ display: openBox ? "block" : "none" }}
            >
                {/* CLOSE BUTTON */}
                <div className="sticky-close">
                    <img
                        src="/images/close-white.svg"
                        alt=""
                        onClick={closeBox}
                        style={{ cursor: "pointer" }}
                    />
                </div>

                {/* PREVIOUS ARROW */}
                {showPrev && (
                    <div
                        className="lightbox-prev"
                        onClick={onPrev}
                        style={{
                            position: "absolute",
                            top: "40%",
                            left: "300px",
                            fontSize: "80px",
                            color: "#f75891",
                            cursor: "pointer",
                            userSelect: "none"
                        }}
                    >
                        ‹
                    </div>
                )}

                {/* NEXT ARROW */}
                {showNext && (
                    <div
                        className="lightbox-next"
                        onClick={onNext}
                        style={{
                            position: "absolute",
                            top: "40%",
                            right: "300px",
                            fontSize: "80px",
                            color: "#f75891",
                            cursor: "pointer",
                            userSelect: "none"
                        }}
                    >
                        ›
                    </div>
                )}

                {/* IMAGE */}
                <div
                    className="lightbox"
                    id="img1"
                    style={{ display: openBox ? "block" : "none" }}
                >
                    <span>
                        <img src={image} alt="" />
                    </span>
                </div>
            </div>
        </div>
    );
}
